export default "__VITE_ASSET__2a5ecbe1__"